import $ from 'jquery'
import Swal from 'sweetalert2'

const states = new WeakMap()
const readers = new WeakMap()
// A reader observes the actual draft, including fields on other tabs and nested editors.
export function registerModalDraft(element, read) {
  readers.set(element, read)
  return () => { readers.delete(element); states.delete(element) }
}
function snapshot(element) {
  if (readers.has(element)) return JSON.stringify(readers.get(element)())
  return JSON.stringify([...element.querySelectorAll('input, textarea, select')]
    .filter(input => !input.closest('[data-discard-ignore], .commercial-tree-toolbar') && !['search', 'hidden', 'button', 'submit'].includes(input.type))
    .map(input => [input.id || input.name, input.type === 'checkbox' || input.type === 'radio' ? input.checked : input.value]))
}
export function markModalSaved(element) {
  if (element) states.set(element, { initial: snapshot(element), saved: true })
}
export function installModalChanges() {
  $(document).on('show.bs.modal.discardGuard', '.modal', function () {
    if (this.matches('[data-discard-ignore]') || /filtro|filter/i.test(this.id)) return
    states.set(this, { initial: snapshot(this) })
  })
  $(document).on('hide.bs.modal.discardGuard', '.modal', function (event) {
    const element = this, state = states.get(element)
    if (!state || state.saved || snapshot(element) === state.initial) return
    event.preventDefault()
    if (state.asking) return
    state.asking = true
    const keepFocus = event => { if (Swal.getContainer()?.contains(event.target)) event.stopImmediatePropagation() }
    Swal.fire({ icon: 'warning', title: 'Descartar alterações?', text: 'As alterações não salvas serão descartadas. Deseja mesmo sair?', showCancelButton: true, confirmButtonText: 'Descartar e sair', cancelButtonText: 'Continuar editando', focusCancel: true, returnFocus: false, keydownListenerCapture: true,
      didOpen() {
        const layers = [...document.querySelectorAll('.modal.show, .relationship-workspace')].map(layer => Number(getComputedStyle(layer).zIndex) || 0)
        Swal.getContainer().style.zIndex = String(Math.max(1060, ...layers) + 20)
        document.addEventListener('focusin', keepFocus, true)
        Swal.getCancelButton()?.focus()
      },
      willClose() { document.removeEventListener('focusin', keepFocus, true) }
    }).then(result => {
      state.asking = false
      if (!element.isConnected) return
      if (result.isConfirmed) { state.saved = true; $(element).modal('hide') }
      else element.querySelector('.modal-content input:not(:disabled), .modal-content button')?.focus()
    })
  })
  $(document).on('hidden.bs.modal.discardGuard', '.modal', function () { states.delete(this) })
}
